import * as _ from 'lodash';

import { isNullOrUndefined } from '../../utilities/stringUtil';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { API } from '../../utilities/constants';
import AuthProvider, { needTokenUpdate } from '../../utilities/authProvider';

/**
 * CCUS連携用パラメータを作成
 * @param {int} company_id
 * @return {object}requestConnectionCcusParam:CCUS連携用パラメーター
 * */
const requestConnectionCcusParam = company_id => {
  const requestConnectionCcusParam = Object.create(null);
  if (!isNullOrUndefined(company_id)) {
    requestConnectionCcusParam.company_id = company_id;
  }
  return requestConnectionCcusParam;
};

const getExportExcelRequestOptions = (companyId, params) => {
  const getUrl = async () => {
    let token = SessionStorageService.getToken();
    if (needTokenUpdate(token)) {
      token = await AuthProvider.instance.silentTokenUdate();
    }
    return `${
      API.endpoint
    }/api/private/ccus/companies/${companyId}/workers/bulk_export.xlsx?excel_token=${token}`;
  };

  const getTemplateUrl = async () => {
    let token = SessionStorageService.getToken();
    if (needTokenUpdate(token)) {
      token = await AuthProvider.instance.silentTokenUdate();
    }
    return `${
      API.endpoint
    }/api/private/ccus/companies/${companyId}/workers/download_template.xlsx?excel_token=${token}`;
  };

  return {
    getUrl,
    getTemplateUrl,
    params: _.pickBy(params, _.identity),
  };
};

/**
 *
 * */
const WorkersService = {
  requestConnectionCcusParam,
  getExportExcelRequestOptions,
};

export default WorkersService;



// WEBPACK FOOTER //
// ./src/services/workers/WorkersService.js